var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export * from './mqtt';
export * from './sqs';
export class MessageWrapper {
    constructor(_apiClient, _msg, _replyId) {
        this._apiClient = _apiClient;
        this._msg = _msg;
        this._replyId = _replyId;
    }
    getMessage() {
        return this._msg;
    }
    getMessageData() {
        return this._msg.data.data;
    }
    getMessageMetadata() {
        return this._msg.data.metadata;
    }
    sendAck() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._replyId)
                this._apiClient.sendAck(this._replyId, this._msg.data.metadata.originChannel);
        });
    }
}
export class AsyncApiPipe {
    constructor(_apiClient, _manualAck = false) {
        this._apiClient = _apiClient;
        this._manualAck = _manualAck;
    }
    sendTo(targetApiClient, messages) {
        return __awaiter(this, void 0, void 0, function* () {
            const outputMessages = [];
            for (let message of messages) {
                const wrapperMsg = this._apiClient.toMessageWrapper(message);
                if (wrapperMsg) {
                    yield targetApiClient.send(wrapperMsg.getMessage());
                    if (!this._manualAck)
                        wrapperMsg.sendAck();
                }
            }
            return outputMessages;
        });
    }
}
